import script from "./Doctor.vue?vue&type=script&setup=true&lang=js"
export * from "./Doctor.vue?vue&type=script&setup=true&lang=js"

import "./Doctor.vue?vue&type=style&index=0&id=02616217&lang=scss&scoped=true"

import exportComponent from "/Users/oleksandrpolishchuk/Documents/dev/eye-test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02616217"]])

export default __exports__